export default __webpack_public_path__ + "static/media/Dice-6.6842f58f.png";